import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import FileUpload from '../../../../components/FileUpload';
import Input from '../../../../components/input-text';
import config from '../../../../config';

import Translate from '../../../../components/Translate';
import SaveAndCancel from '../../../../components/ProceedAndExitButtons'
import {addNotification as addNotificationAction} from '../../../../services/notification/action';
import {updateUserData as updateUserDataAction} from '../../../../services/user/action';
import {changePassword as changePasswordApi, updateUser as updateUserApi} from '../../../../services/user/api';
import CustomInput from "../../../../components/input-text";
import './UserProfile.css'
import {titleStyles} from "../../../../utils/General";

const styles = {
    wrapper: {
        padding: '40px',
        display: 'flex',
        flexDirection: 'row',
    },
    title: {
        color: 'rgb(39, 114, 145)',
        marginBottom: '40px',
    },
    firstName: {
        width: '100%',
        marginBottom: '10px',
    },
    subTitle: {
        color: 'rgb(39, 114, 145)',
        fontSize: '14px',
        paddingBottom: '5px',
        width: '100%',
        display: "flex",
        alignItems: "center",
        columnGap: "10px"
    }
};

class UserProfile extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            firstName: '',
            lastName: '',
            email: '',
            contactNumber: '',
            oldPassword: '',
            newPassword: '',
            thumbUrl: '',
            saveDisabled: false,
            goodAnswer: '',
            badAnswer: ''
        };
    }

    componentDidMount() {
        const {user} = this.props;
        this.setState({...user});
    }

    getUserDataFromState = () => {
        const {
            firstName, lastName, email, contactNumber, thumbUrl
        } = this.state;

        return {
            firstName,
            lastName,
            email,
            contactNumber: contactNumber != null ? contactNumber : 'no number',
            thumbUrl: thumbUrl != null ? thumbUrl : ''
        };
    };

    saveUserData = () => {

        const {
            oldPassword, newPassword
        } = this.state;

        if (oldPassword && newPassword) {
            this.changePassword();
        }

        const userData = this.getUserDataFromState();
        const {updateUserData, close, addNotification, user} = this.props;

        this.setState({
            saveDisabled: true,
        });

        if (user.canChangeHimselfInfo) {
            updateUserApi(userData)
                .then((userUpdatedData) => {
                    updateUserData(userUpdatedData);
                    close();
                    addNotification('userInfoUpdated', config.notificationLevels.success);
                })
                .catch(() => {
                    addNotification('somethingWentWrong', config.notificationLevels.error);
                })
                .finally(() => {
                    this.setState({
                        saveDisabled: false,
                    });
                });
        }

    };

    handleChange = name => (value) => {
        this.setState({
            [name]: value,
        });
    };

    handlePassChange = name => (value) => {
        this.setState({
            [name]: value,
        });
    };

    getUserDataForChangePassword = () => {
        const {
            email, oldPassword, newPassword
        } = this.state;

        return {
            email, oldPassword, newPassword
        };
    }

    changePassword = () => {
        const userData = this.getUserDataForChangePassword();
        const {updateUserData, addNotification} = this.props;

        this.setState({
            saveDisabled: true,
        });

        changePasswordApi(userData)
            .then((userUpdatedData) => {
                updateUserData(userUpdatedData);
                addNotification('passwordChanged', config.notificationLevels.success);
            })
            .catch((e) => {
                addNotification('passwordChangeError', config.notificationLevels.error);
            })
            .finally(() => {
                this.setState({
                    saveDisabled: false,
                });
            });
    }
    
    render() {
        const {close} = this.props;
        const {user} = this.props;
        const {
            firstName,
            lastName,
            contactNumber,
            email,
            thumbUrl,
            oldPassword,
            newPassword
        } = this.state;

        return (
            <div className="un-selectable" style={styles.wrapper}>
                <div>
                    <h1 style={titleStyles.title}>
                        {user.authorities[0].replace("ROLE_", "")}
                    </h1>
                    <div style={{display: 'flex', flexDirection: 'row', marginBottom: '20px'}}>
                        <div className={user.canChangeHimselfInfo ? "" : "disabled-div"}
                             style={{display: 'flex', justifyContent: 'center', marginRight: '40px'}}>
                            <FileUpload windowSize={120} editIconSize={36} progressSize={22} editIconPos={0}
                                        handleChange={this.handleChange('thumbUrl')} image={thumbUrl}/>
                        </div>
                        <div>
                            <div className={user.canChangeHimselfInfo ? "" : "disabled-div"} style={styles.firstName}>
                                <div style={styles.subTitle}>
                                    <Translate text="firstName"/>
                                </div>
                                <Input controlled maxLength={10} inputStyles={{width: '100%', height: '45px'}}
                                       value={firstName}
                                       handleChange={this.handleChange('firstName')}/>
                            </div>
                            <div className={user.canChangeHimselfInfo ? "" : "disabled-div"} style={styles.lastName}>
                                <div style={styles.subTitle}>
                                    <Translate text="lastName"/>
                                </div>
                                <Input controlled maxLength={15} inputStyles={{width: '100%', height: '45px'}}
                                       value={lastName}
                                       handleChange={this.handleChange('lastName')}/>
                            </div>
                        </div>
                    </div>

                    <div style={{display: "flex", flexDirection: "column", gap: '10px', marginBottom: '20px'}}>
                        <div>
                            <div style={styles.subTitle}>
                                <Translate text="phoneNumber"/>
                            </div>
                            <Input controlled inputStyles={{width: '100%', height: '45px'}} value={contactNumber}
                                   handleChange={this.handleChange('contactNumber')}/>
                        </div>
                        <div >
                            <div style={styles.subTitle}>
                                <Translate text="email"/>
                            </div>
                            <Input
                                controlled
                                disabled
                                inputStyles={{
                                    width: '100%', height: '45px', backgroundColor: 'transparent', color: '#A4ADC1',
                                }}
                                value={email}
                            />
                        </div>
                        <div>
                            <div className={'user-profile-password-header'}>
                                <Translate text="oldPassword"/>
                            </div>
                            <CustomInput
                                controlled
                                handleChange={this.handlePassChange('oldPassword')}
                                value={oldPassword}
                                maxLength={20}
                                inputStyles={{width: "100%", height: '45px'}}
                                style={{}}
                            />
                        </div>
                        <div>
                            <div className={'user-profile-password-header'}>
                                <Translate text="newPassword"/>
                            </div>
                            <CustomInput
                                controlled
                                handleChange={this.handlePassChange('newPassword')}
                                value={newPassword}
                                maxLength={20}
                                inputStyles={{width: "100%", height: '45px'}}
                            />
                        </div>
                    </div>

                    <SaveAndCancel exitText="cancel" proceedText="save" exitAction={close}
                                   proceedAction={this.saveUserData}/>
                </div>
            </div>
        );
    }
}

UserProfile.propTypes = {
    user: PropTypes.object.isRequired,
    close: PropTypes.func.isRequired,
    addNotification: PropTypes.func.isRequired,
    updateUserData: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
    user: state.user,
});

const mapDispatchToProps = {
    addNotification: addNotificationAction,
    updateUserData: updateUserDataAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserProfile);



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/header/UserProfile.jsx